import React, { Component } from 'react';
import GroupsTable from './../components/GroupsComponents/GroupTable';

class GroupsView extends Component {

    render() {
        return (
            <React.Fragment>
                <GroupsTable />
            </React.Fragment>
        );
    }
}

export default GroupsView;